import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";

import LogoDark from "../../assets/logos/Iris-Logo-TRADEMARKED-Web_Dark Mode.png";
import LogoLight from "../../assets/logos/Iris-Logo-TRADEMARKED-Web_Full Color.png";

const SidebarLogo = ({ isNightMode, onClick }) => (
  <div>
    <Image
      responsive
      src={isNightMode ? LogoDark : LogoLight}
      alt="iris-logo"
      width={75}
      style={{ margin: "auto", marginBottom: "5px" }}
      onClick={onClick}
    />
  </div>
);

SidebarLogo.propTypes = {
  isNightMode: PropTypes.bool,
  onClick: PropTypes.func
};
export default SidebarLogo;
